// Local-development stubs for MAT-2005 (disable_login_page on domain_settings).
// Scratch file for manual testing — not intended to be committed.
//
// Enable in the browser console, then reload:
//
//   localStorage.setItem('mock_server_enabled', '1');
//   localStorage.setItem('mock_server_scenario', 'loginPageDisabled');
//
// Scenarios (see mocks/browser.ts):
//   loginPageDisabled       real response + the flag — keeps real SSO providers,
//                           so ?auto_login_sso_provider_id=<id> still signs in
//   loginPageDisabledNoSso  pure stub, flag on, no providers, no network
//   loginPageSlow           flag off, 5s delay — shows the loader branch
//
// Turn off with:
//
//   localStorage.removeItem('mock_server_enabled');

import { bypass, delay, http, HttpResponse, passthrough } from 'msw';

// Matches the develop backend (https://elis.develop.r8.lol/api/v1/...) and a
// local proxy (/api/v1/...) alike.
const DOMAIN_SETTINGS_URL = /\/api\/v1\/internal\/domain_settings(?:\?.*)?$/;

// The response is snake_case on the wire — the api-client camelCases it.
type DomainSettingsResponseBody = {
  disable_login_page?: boolean;
  sso_providers?: Array<{
    id: number;
    name: string;
    send_redirect_url: boolean;
    api_url: string;
  }>;
};

// Everything else reaches the real backend, and stays out of the "unhandled
// request" warnings that would otherwise flood the console once signed in.
const passthroughEverythingElse = http.all('*', () => passthrough());

// Keeps the real providers so the autologin exception can be exercised for real:
// the disabled message must NOT appear when a provider id is in the URL.
export const loginPageDisabledHandlers = [
  http.get(DOMAIN_SETTINGS_URL, async ({ request }) => {
    const response = await fetch(bypass(request));
    const original: DomainSettingsResponseBody = await response.json();

    return HttpResponse.json({ ...original, disable_login_page: true });
  }),
  passthroughEverythingElse,
];

export const loginPageDisabledNoSsoHandlers = [
  http.get(DOMAIN_SETTINGS_URL, () =>
    HttpResponse.json({ disable_login_page: true, sso_providers: [] })
  ),
  passthroughEverythingElse,
];

export const loginPageSlowHandlers = [
  http.get(DOMAIN_SETTINGS_URL, async ({ request }) => {
    await delay(5000);

    const response = await fetch(bypass(request));
    const original: DomainSettingsResponseBody = await response.json();

    return HttpResponse.json({ ...original, disable_login_page: false });
  }),
  passthroughEverythingElse,
];
